function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var INPAY_SDK_ERROR_ID = 119;
/**
 *  Inpay SDK 의 Error 상황별 CDOE, MESSAGE 를 정의합니다.<br>
 * error CODE 값은 Inface 에서 부여하는 ID(3자리) 와 InpayErrorCode.CODE 값을 조합한 6자리를 생성합니다.<br>
 * ID 는 package.json 의 inface.id 값 입니다.
 *
 * @memberof module:INPAY_ERROR
 * @typedef ErrorCode
 * @property {JSON} FAILED_INITIALIZE { CODE: 101, MESSAGE: 'Failed to initialize Inpay SDK during startup process' }
 * @property {JSON} FAILED_FINALIZE { CODE: 102, MESSAGE: 'Failed to finalize Inpay SDK during stop process' }
 * @property {JSON} ALREADY_STARTED { CODE: 103, MESSAGE: 'Inpay SDK is already started' }
 * @property {JSON} ALREADY_IN_PURCHASE_PROCESS { CODE: 104, MESSAGE: 'Inpay SDK is already in purchase process' }
 * @property {JSON} FAILED_NOT_INITIALIZE { CODE: 111, MESSAGE: 'Failed to execute method, you have to initialize first' }
 * @property {JSON} PRECONDITION_MISMATCH { CODE: 129, MESSAGE: 'Can not execute command properly, precondition is mismatched' }
 * @property {JSON} FAILED_ALLTEM_ITEM_LIST { CODE: 161, MESSAGE: 'Failed to get Item List from AllTem' }
 * @property {JSON} FAILED_STAMP_ISSUE_KRPC { CODE: 171, MESSAGE: 'Failed Stamp ISSUE KRPC' }
 * @property {JSON} FAILED_DIRECT_PAYMENT { CODE: 172, MESSAGE: 'Failed DIRECT PAYMENT' }
 * @property {JSON} FAILED_STAMP_PURCHASE { CODE: 173, MESSAGE: 'Failed Stamp transaction at PURCHASE' }
 * @property {JSON} USER_STOPS_PAYMENT { CODE: 174, MESSAGE: 'User stops payment at payment page' }
 * @property {JSON} PAY_LIMIT_USER { CODE: 175, MESSAGE: 'Failed payment because the payment is limited for this user' }
 * @property {JSON} STOPPED_PURCHASING { CODE: 176, MESSAGE: 'Interrupted purchasing process by stopPurchasing method' }
 * @property {JSON} FAILED_ISSUE_DIPAY_VIOLATED_LIMIT_POLICY
 *                                     { CODE: 179, MESSAGE: 'Failed Stamp ISSUE KRPC because Violated limit policy of direct payment' }
 * @property {JSON} FAILED_STAMP_RESTORE_KRPC { CODE: 181, MESSAGE: 'Failed Stamp RESTORE KRPC' }
 * @property {JSON} FAILED_STAMP_RESTORE { CODE: 182, MESSAGE: 'Failed Stamp RESTORE' }
 * @property {JSON} INVALID_PARAMETER { CODE: 301, MESSAGE: 'Invalid Parameter' }
 * @property {JSON} INVALID_PARAMETER_FUNCTION { CODE: 302, MESSAGE: 'Invalid Parameter, parameter is supposed to be function' }
 * @property {JSON} INVALID_PARAMETER_NO_VALUE { CODE: 303, MESSAGE: 'Invalid Parameter, required parameters are supposed to have value' }
 * @property {JSON} INVALID_PARAMETER_NAME { CODE: 304, MESSAGE: 'Invalid Parameter, you have called with unsupported parameter name' }
 * @property {JSON} UNKNOWN { CODE: 500, MESSAGE: 'Unknown error occurs' }
 * @property {JSON} WRONG_IMPLEMENT_ERROR { CODE: 501, MESSAGE: 'SDK Implements wrong' }
 * @property {JSON} ALREADY_USED_PORT { CODE: 511, MESSAGE: 'The port for direct payment for web is already in use' }
 * @property {JSON} TCP_SERVER_ERROR { CODE: 512, MESSAGE: 'Tcp server error represented' }
 * @property {JSON} HTTP_UNRECOGNIZED { CODE: 600, MESSAGE: 'Unrecognized http error occurs' }
 * @property {JSON} HTTP_UNAUTHORIZED { CODE: 641, MESSAGE: 'Unauthorized' }
 * @property {JSON} HTTP_NOT_FOUND { CODE: 644, MESSAGE: 'Can not find resource' }
 * @property {JSON} HTTP_NOT_ALLOWED { CODE: 645, MESSAGE: 'Method Not Allowed' }
 * @property {JSON} HTTP_GONE { CODE: 649, MESSAGE: 'The requested resource had removed because it expired' }
 * @property {JSON} HTTP_INTERNAL_SERVER_ERROR { CODE: 650, MESSAGE: 'Internal Server Error' }
 * @property {JSON} STAMP_SPECIFIC_ERROR_BASE_CODE { CODE: 700, MESSAGE: 'This code represents stamp specific error base code' }
 * @property {JSON} NOT_EXIST_USER { CODE: 701, MESSAGE: 'Failed Stamp issue because this user does not exist' }
 * @property {JSON} DORMANT_USER { CODE: 702, MESSAGE: 'Failed Stamp issue because this user is dormant' }
 * @property {JSON} NOT_AUTHENTICATED_USER { CODE: 703, MESSAGE: 'Failed Stamp issue because this user is not authnticated' }
 * @property {JSON} NOT_SEARCHABLE_USER { CODE: 704, MESSAGE: 'Failed Stamp issue because this user is not authnticated' }
 * @property {JSON} DIPAY_GENERAL_ERROR { CODE: 800, MESSAGE: 'Failed payment' }
 */
var InpayErrorCode = {
  // 1xx: SDK Operation
  FAILED_INITIALIZE: {
    CODE: 101,
    MESSAGE: 'Failed to initialize Inpay SDK during startup process'
  },
  FAILED_FINALIZE: {
    CODE: 102,
    MESSAGE: 'Failed to finalize Inpay SDK during stop process'
  },
  ALREADY_STARTED: {
    CODE: 103,
    MESSAGE: 'Inpay SDK is already started'
  },
  ALREADY_IN_PURCHASE_PROCESS: {
    CODE: 104,
    MESSAGE: 'Inpay SDK is already in purchase process'
  },
  FAILED_NOT_INITIALIZE: {
    CODE: 111,
    MESSAGE: 'Failed to execute method, you have to initialize first'
  },
  PRECONDITION_MISMATCH: {
    CODE: 129,
    MESSAGE: 'Can not execute command properly, precondition is mismatched'
  },
  FAILED_ALLTEM_ITEM_LIST: {
    CODE: 161,
    MESSAGE: 'Failed to get Item List from AllTem'
  },
  FAILED_STAMP_ISSUE_KRPC: {
    CODE: 171,
    MESSAGE: 'Failed Stamp ISSUE KRPC'
  },
  FAILED_DIRECT_PAYMENT: {
    CODE: 172,
    MESSAGE: 'Failed DIRECT PAYMENT'
  },
  FAILED_STAMP_PURCHASE: {
    CODE: 173,
    MESSAGE: 'Failed Stamp transaction at PURCHASE'
  },
  USER_STOPS_PAYMENT: {
    CODE: 174,
    MESSAGE: 'User stops payment at payment page'
  },
  PAY_LIMIT_USER: {
    CODE: 175,
    MESSAGE: 'Failed payment because the payment is limited for this user'
  },
  STOPPED_PURCHASING: {
    CODE: 176,
    MESSAGE: 'Interrupted purchasing process by stopPurchasing method'
  },
  FAILED_ISSUE_DIPAY_VIOLATED_LIMIT_POLICY: {
    CODE: 179,
    MESSAGE: 'Failed Stamp ISSUE KRPC because Violated limit policy of direct payment'
  },
  FAILED_STAMP_RESTORE_KRPC: {
    CODE: 181,
    MESSAGE: 'Failed Stamp RESTORE KRPC'
  },
  FAILED_STAMP_RESTORE: {
    CODE: 182,
    MESSAGE: 'Failed Stamp RESTORE'
  },
  // 3xx: Parameters
  INVALID_PARAMETER: {
    CODE: 301,
    MESSAGE: 'Invalid Parameter'
  },
  INVALID_PARAMETER_FUNCTION: {
    CODE: 302,
    MESSAGE: 'Invalid Parameter, parameter is supposed to be function'
  },
  INVALID_PARAMETER_NO_VALUE: {
    CODE: 303,
    MESSAGE: 'Invalid Parameter, required parameters are supposed to have value'
  },
  INVALID_PARAMETER_NAME: {
    CODE: 304,
    MESSAGE: 'Invalid Parameter, you have called with unsupported parameter name'
  },
  // 5xx: Internal Errors
  UNKNOWN: {
    CODE: 500,
    MESSAGE: 'Unknown error occurs'
  },
  WRONG_IMPLEMENT_ERROR: {
    CODE: 501,
    MESSAGE: 'SDK Implements wrong'
  },
  ALREADY_USED_PORT: {
    CODE: 511,
    MESSAGE: 'The port for direct payment for web is already in use'
  },
  TCP_SERVER_ERROR: {
    CODE: 512,
    MESSAGE: 'Tcp server error represented'
  },
  // 6xx: Http Errors - http status code 와 헷갈리지 않기 위해
  HTTP_UNRECOGNIZED: {
    CODE: 600,
    MESSAGE: 'Unrecognized http error occurs'
  },
  HTTP_UNAUTHORIZED: {
    CODE: 641,
    MESSAGE: 'Unauthorized'
  },
  HTTP_NOT_FOUND: {
    CODE: 644,
    MESSAGE: 'Can not find resource'
  },
  HTTP_NOT_ALLOWED: {
    CODE: 645,
    MESSAGE: 'Method Not Allowed'
  },
  HTTP_GONE: {
    CODE: 649,
    MESSAGE: 'The requested resource had removed because it expired'
  },
  HTTP_INTERNAL_SERVER_ERROR: {
    CODE: 650,
    MESSAGE: 'Internal Server Error'
  },
  // Stamp 상세 에러 (701~799)
  STAMP_SPECIFIC_ERROR_BASE_CODE: {
    // 설명 (order/reserve code, stamp code)
    CODE: 700,
    MESSAGE: 'This code represents stamp specific error base code'
  },
  NOT_EXIST_USER: {
    // 존재하지 않는 유저 (o/r 9001104, stamp 29043)
    CODE: 701,
    MESSAGE: 'Failed Stamp issue because this user does not exist'
  },
  DORMANT_USER: {
    // 휴면계정 (o/r 1001136, stamp 29044)
    CODE: 702,
    MESSAGE: 'Failed Stamp issue because this user is dormant'
  },
  NOT_AUTHENTICATED_USER: {
    // 본인인증 안 된 유저 - ATL 1.0 (o/r 1001125, stamp 29045)
    CODE: 703,
    MESSAGE: 'Failed Stamp issue because this user is not authnticated'
  },
  NOT_SEARCHABLE_USER: {
    // 사용자 검색 서비스에 사용자 없음 (o/r 1001106, stamp 29046)
    CODE: 704,
    MESSAGE: 'Failed Stamp issue because this user is not authnticated'
  },
  // 직접결제 상세 에러 (800~849)
  DIPAY_GENERAL_ERROR: {
    CODE: 800,
    MESSAGE: 'Failed payment'
  }
};

/**
 *
 * @returns {module:INPAY_ERROR.ErrorCode}
 */
// TODO!!! 에러코드 재정의 필요
function freezeErrorCode(errorObject) {
  var codeId = INPAY_SDK_ERROR_ID * 1000;
  var Errors = Object.freeze(_objectSpread({}, errorObject));
  var arr = Object.values(Errors);
  for (var i = 0; i < arr.length; i++) {
    var prop = arr[i];
    if (prop.CODE < 0 || prop.CODE.toString().length > 3) {
      throw new Error('SDK error code is supposed to be 0 or more and under 1000');
    }
    prop.CODE = codeId + prop.CODE;
    Object.freeze(prop);
  }
  return Errors;
}

/**
 * @type ErrorCode
 */
var ErrorCode = freezeErrorCode(InpayErrorCode);
var StampError = Object.freeze({
  // 상품 지급 실패
  CODE_BILLING_RESTORE_DELIVERY_ERR: {
    error_code: 100105,
    error: 'Inpay: Failed to restore delivery',
    error_description: ''
  },
  // 상품 지급 부분 실패
  CODE_BILLING_RESTORE_PARTIAL_DELIVERY_ERR: {
    error_code: 100106,
    error: 'Inpay: Failed to restore partial delivery',
    error_description: ''
  },
  // 복구할 상품이 없음
  CODE_BILLING_RESTORE_EMPTY_TRANSACTIONS_ERR: {
    error_code: 100107,
    error: 'Inpay: There is no transactions to restore',
    error_description: ''
  }
});
export { ErrorCode, StampError };